import { Record } from 'immutable';
import SourceApplication from 'automation-ui-canvas/data/records/SourceApplication';
import WorkflowsUser from 'automation-ui-canvas/data/records/WorkflowsUser';
export default Record({
  updatedAt: null,
  updatedByUser: new WorkflowsUser(),
  sourceApplication: new SourceApplication()
}, 'UpdateSource');